import React from 'react';
import classnames from 'classnames';

// Components
import { WpText } from '../text';

import './WpChoice.scss';

export interface Props {
  /** A unique identifier for the choice */
  id: string;
  /**	Label for the choice */
  label: React.ReactNode;
  /**  Content to display inside the choice */
  children?: React.ReactNode;
  /** Additional text to aide in use */
  descriptionText?: string;
  /** Callback when clicked */
  onClick?(): void;
  /** Callback when mouse over */
  onMouseOver?(): void;
  /** Callback when mouse out */
  onMouseOut?(): void;
  /** when we want to use a component instead
   * of label we can hide the label */
  component?: React.ReactNode;
}

const WpChoice: React.FC<Props> = ({
  id,
  label,
  children,
  descriptionText,
  onClick,
  onMouseOut,
  onMouseOver,
  component,
}: Props) => {
  const hasComponent = Boolean(component);
  const baseClassName = 'WpChoice';

  const classes = classnames(baseClassName, hasComponent ? `${baseClassName}--hasComponent` : false);
  return (
    <label className={classes} htmlFor={id} onClick={onClick} onMouseOver={onMouseOver} onMouseOut={onMouseOut}>
      <div className={`${baseClassName}__control`}>{children}</div>
      <div className={`${baseClassName}__label`}>
        {!hasComponent ? (
          <>
            <span>{label}</span>
            <WpText variant="bodySm" color="gray-600" tag="span">
              {descriptionText}
            </WpText>
          </>
        ) : (
          <>{component}</>
        )}
      </div>
    </label>
  );
};

export default WpChoice;
